import React from "react";

import { maybeGetClosureFor } from "@kazoohr/helpers";

import { Flex } from "../Flex";
import { IconButton } from "../IconButton";
import { UtilityText } from "../UtilityText";

import styles from "./DataTable.scss";
import { sortDirectionIcons } from "./types";
import type { SortDirection, TableColumn } from "./types";

interface SortableHeaderProps {
  column: TableColumn;
  /**
   * Function that is called when a heading column is clicked -- for sorting purposes
   */
  onClick?: (clickedColumnHeaderName: string) => void;
  sort?: SortDirection | null;
}

export function SortableHeader({ column, onClick, sort }: SortableHeaderProps) {
  const sortDir = sort && sortDirectionIcons[sort];
  const header =
    typeof column.header === "function" ? column.header() : column.header;
  const headerString = String(header);
  const onSortClick = maybeGetClosureFor(onClick, headerString);
  return (
    <div className={styles.sortableHeader}>
      {sortDir ? (
        <Flex alignItems="center" justifyContent="center">
          <UtilityText size="small">{header}</UtilityText>
          &nbsp;
          <span>
            <IconButton
              iconSize={8}
              icon={sortDir}
              variant="subtle"
              onClick={onSortClick}
            />
          </span>
        </Flex>
      ) : (
        <UtilityText size="small">{header}</UtilityText>
      )}
    </div>
  );
}
